<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ser" style="margin-top: 25%;"><img alt="page11" id="rps11" src="Images/page-11.jpg"/></p>
<p class="h0" id="d7e42011"><a href="#/Text/Susa_ISBN9781588169167_epub_toc_r1#d7e1606"><span style="color: #C75334;">THE HOME<br/>THAT<br/>WELCOMES</span></a></p>
<p class="ser" id="rps11a"><img alt="page11" src="Images/page-11.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Susa_ISBN9781588169167_epub_part01_r1.vue?051e4210